import $ from 'jquery'

function init () {
  $('.solution-finder-module').each(function () {
    initSolutionFinder($(this))
  })
}

function initSolutionFinder (el) {
  let $this = el,
    $selectRole = $this.find('#solution-finder-role'),
    $selectSolution = $this.find('#solution-finder-solution'),
    $selectSolutionWrapper = $selectSolution.parent('.formRow--dropdown-wrapper'),
    $btnWrapper = $this.find('#solution-finder-btn-wrapper'),
    $btn = $btnWrapper.find('.btn'),
    solutionUrl

  $selectRole.on('change', function () {
    let selectedVal = $(this).val()

    $selectSolutionWrapper.find('.formRow--dropdown-list-item').not('[data-solution-role=' + selectedVal + ']').hide()
    $selectSolutionWrapper.find('.formRow--dropdown-list-item[data-solution-role=' + selectedVal + ']').show()
    $selectSolution.trigger('reset')
    $selectSolutionWrapper.removeClass('disabled')
    $this.find('.info-bubble').hide()
    $this.find('.info-bubble[data-info-bubble=' + selectedVal + ']').show()
    setBtnStatus()

  })

  $selectSolution.on('change', function () {
    setBtnStatus()
  })

  $btn.on('click', function (e) {
    e.preventDefault()
    //console.log(solutionUrl);
    if (solutionUrl != '' && solutionUrl != undefined && solutionUrl != null) {
      window.location.href = solutionUrl
    }
  })

  function setBtnStatus () {
    if ($selectRole.val() != '' && $selectSolution.val() != '') {
      $btnWrapper.removeClass('disabled')
      solutionUrl = $selectSolutionWrapper.find('.formRow--dropdown-list-item[data-solution-role=' + $selectRole.val() + '][data-dropdown-value=' + $selectSolution.val() + ']').data('solution-url')
    } else {
      $btnWrapper.addClass('disabled')
      solutionUrl = ''
    }
  }
}

export default {
  init
}
